import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseMetric } from './base-metric';
export class UntilExperience {
  constructor(config) {
    if (config instanceof BaseMetric) {
      this.experience = config;
    } else {
      this.experience = config.experience;
      this.useFmpAsUntilStopTime = config.useFmpAsUntilStopTime;
    }
  }
  /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */


  getFmp() {
    var _marks$UntilExperienc;

    const {
      marks,
      stop
    } = this.experience.getData();
    return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
  }

  getDependencyStopTime() {
    if (this.useFmpAsUntilStopTime) {
      return this.getFmp();
    }

    return this.experience.getData().stop;
  }

  getIsSegmentLoadOverrided() {
    if (this.useFmpAsUntilStopTime) {
      const {
        marks
      } = this.experience.getData();
      return marks[UntilExperience.FMP] ? true : false;
    }

    return false;
  }

  getKey() {
    return this.experience.getData().key;
  }

}

_defineProperty(UntilExperience, "FMP", 'fmp');